import React from 'react'

const EditIcon = () => {
    return (
        <svg 
            version="1.0" 
            xmlns="http://www.w3.org/2000/svg"
            width="20" height="20" 
            viewBox="0 0 64.000000 64.000000"
            preserveAspectRatio="xMidYMid meet"
        >
            <g transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)"
                fill="#000000" stroke="none">
                <path d="M491 547 c-8 -10 -4 -20 20 -43 25 -24 31 -26 39 -14 14 21 12 28 -10 50 -23 23 -34 25 -49 7z"/>
                <path d="M96 508 c-13 -18 -16 -56 -16 -201 0 -242 -16 -227 240 -227 190 0 191 0 216 25 22 22 25 32 22 93 -2 37 -7 67 -13 67 -5 0 -12 -34 -15 -75 l-5 -75 -205 0 -205 0 -3 184 c-2 127 1 188 9 197 8 9 34 14 80 14 39 0 69 4 69 10 0 6 -33 10 -79 10 -71 0 -82 -2 -95 -22z"/>
                <path d="M367 422 l-87 -88 30 -29 30 -29 85 84 c47 47 85 89 85 96 0 10 -41 54 -51 54 -2 0 -44 -40 -92 -88z"/>
                <path d="M257 283 c-7 -35 -4 -37 28 -26 l26 8 -24 23 -24 23 -6 -28z" />
            </g>
        </svg>
    )
}

export default EditIcon